import { hot } from 'react-hot-loader/root';
import React from 'react';
import { MujiRouter, Router } from '@souche-f2e/muji';
const routes = [
    {
        "path": "/",
        "children": [
            {
                "path": "",
                "component": require('../pages/index.tsx').default
            },
            {
                "path": "error",
                "children": [
                    {
                        "path": "",
                        "component": require('../pages/error/index.tsx').default
                    }
                ]
            },
            {
                "path": "home",
                "children": [
                    {
                        "path": "",
                        "component": require('../pages/home/index.tsx').default
                    }
                ]
            },
            {
                "path": ":application",
                "children": [
                    {
                        "path": ":features",
                        "children": [
                            {
                                "path": "",
                                "component": require('../pages/$application/$features/index.tsx').default
                            }
                        ]
                    }
                ]
            }
        ],
        "component": require('../pages/_layout/index.tsx').default
    }
];
routes.push({
    "path": "*",
    "component": require('../pages/404').default,
});
const routerOptions = {
    mode: "history",
    routes,
};
export const router = new Router(routerOptions);
const Root = () => (<MujiRouter router={router}/>);
export default hot(Root);
